import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero10 from '../Hero/Hero10';
import Spacing from '../Spacing';
import SectionHeading from '../SectionHeading';
import IconBox from '../IconBox';
import Div from '../Div';
import Card from '../Card';
// import PortfolioSlider2 from '../Slider/PortfolioSlider2';
import TestimonialSlider from '../Slider/TestimonialSlider'
import TestimonialSliderStyle3 from '../Slider/TestimonialSliderStyle3';
import Cta from '../Cta';
import PostSlider from '../Slider/PostSlider';
import CtaStyle2 from '../Cta/CtaStyle2';
import { Icon } from '@iconify/react';
import Slider from 'react-slick';
import Portfolio from '../Portfolio';



const portfolioData = [
    {
        // title: 'Colorful Art Work',
        // subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/bt1.png',
    },
    {
        // title: 'Colorful Art Work',
        // subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/bt2.png',
    },
    {
        // title: 'Colorful Art Work',
        // subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/bt3.png',
    },
    {
        // title: 'Colorful Art Work',
        // subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/bt4.png',
    },
    {
        // title: 'Colorful Art Work',
        // subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/bt5.png',
    },
    {
        // title: 'Colorful Art Work',
        // subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/bt6.png',
    },
];



const PortfolioSlider2 = () => {
    /** Slider Settings **/
    const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
        <div
            {...props}
            className={
                'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
            }
            aria-hidden="true"
            aria-disabled={currentSlide === 0 ? true : false}
        >
            <Icon icon="bi:arrow-left" />
        </div>
    );
    const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
        <div
            {...props}
            className={
                'slick-next slick-arrow' +
                (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
            }
            aria-hidden="true"
            aria-disabled={currentSlide === slideCount - 1 ? true : false}
        >
            <Icon icon="bi:arrow-right" />
        </div>
    );
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: <SlickArrowLeft />,
        nextArrow: <SlickArrowRight />,
        // Added autoplay settings
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    };

    return (
        <Slider {...settings} className="cs-gap-12 cs-arrow_style4">
            {portfolioData.map((item, index) => (
                <Div key={index}>
                    <Portfolio
                        title={item.title}
                        subtitle={item.subtitle}
                        href={item.href}
                        src={item.src}
                        variant="cs-style1 cs-type2 cs-size3"
                    />
                </Div>
            ))}
        </Slider>
    );
}

const serviceData = [
    {
        title: 'Understanding Your Business Needs',
        subtitle:
            'Identifying pain points & opportunities',
        imgUrl: '/images/btp1.png',
        href: '/service',
    },
    {
        title: 'Solution Design',
        subtitle:
            'Wireframing, UI/UX, and tech stack selection.',
        imgUrl: '/images/btp2.png',
        href: '/service',
    },
    {
        title: 'Development',
        subtitle:
            'Websites, apps, CRM, ERP, and digital products.',
        imgUrl: '/images/btp3.png',
        href: '/service',
    },
    {
        title: 'Testing & Optimization',
        subtitle:
            'Ensuring performance, security, and scalability.',
        imgUrl: '/images/btp4.png',
        href: '/service',
    },
    {
        title: 'Deployment & Support',
        subtitle:
            'Seamless launch with ongoing maintenance.',
        imgUrl: '/images/btp5.png',
        href: '/service',
    },
];

const ServiceList = ({ variant }) => {
    const [active, setActive] = useState(0);
    const handelActive = index => {
        setActive(index);
    };
    return (
        <Div className={`cs-iconbox_3_list ${variant ? variant : ''}`}>
            {serviceData.map((item, index) => (
                <Div
                    className={`cs-hover_tab ${active === index ? 'active' : ''}`}
                    key={index}
                    onMouseEnter={() => handelActive(index)}
                >
                    <Link to={item.href} className="cs-iconbox cs-style3">
                        <>
                            <Div className="cs-image_layer cs-style1 cs-size_md">
                                <Div className="cs-image_layer_in">
                                    <img
                                        src={item.imgUrl}
                                        alt="Thumb"
                                        className="w-100 cs-radius_15"
                                    />
                                </Div>
                            </Div>
                            <span className="cs-iconbox_icon cs-center">
                                <svg
                                    width={30}
                                    height={29}
                                    viewBox="0 0 30 29"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M29.3803 3.05172C29.4089 1.94752 28.537 1.02921 27.4328 1.00062L9.43879 0.534749C8.33459 0.506159 7.41628 1.37811 7.38769 2.48231C7.35911 3.58651 8.23106 4.50482 9.33526 4.53341L25.3299 4.94752L24.9158 20.9422C24.8872 22.0464 25.7592 22.9647 26.8634 22.9933C27.9676 23.0218 28.8859 22.1499 28.9144 21.0457L29.3803 3.05172ZM3.37714 28.5502L28.7581 4.4503L26.0039 1.54961L0.622863 25.6495L3.37714 28.5502Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </span>
                            <Div className="cs-iconbox_in">
                                <h2 className="cs-iconbox_title">{item.title}</h2>
                                <Div className="cs-iconbox_subtitle">{item.subtitle}</Div>
                            </Div>
                        </>
                    </Link>
                </Div>
            ))}
        </Div>
    );
};



const accordionData = [
    {
        question: 'What makes your tech solutions different?',
        answer:
            'We don’t just build apps or websites—we create digital experiences that solve real business problems. Our focus is on scalability, security, and user experience, ensuring long-term success.',
    },
    {
        question: 'How do I know if I need a custom CRM or ERP solution?',
        answer:
            'If you’re struggling with data management, customer tracking, or workflow automation, a custom CRM or ERP can streamline your operations, increase efficiency, and help scale your business seamlessly.',
    },
    {
        question: 'How long does it take to develop a website or an app?',
        answer:
            'A basic website takes around 4-6 weeks, while custom web applications and mobile apps may take 3-6 months, depending on complexity and features.',
    },
    {
        question: 'Will my website/app be mobile-friendly?',
        answer:
            'Yes! Every solution we build is fully responsive, ensuring seamless performance across all devices—mobile, tablet, and desktop.',
    },
    {
        question: 'Do you offer ongoing support and maintenance?',
        answer:
            'Yes! We provide continuous support, updates, and optimization to ensure your digital solutions evolve with your business.',
    },
];

const CustomAccordion = () => {
    const [selected, setSelected] = React.useState(null);
    const handelToggle = index => {
        if (selected === index) {
            return setSelected(null);
        }
        setSelected(index);
    };

    return (
        <Div className="cs-accordians cs-style1">
            {accordionData.map((item, index) => (
                <Div
                    className={`cs-accordian ${selected === index ? 'active' : ''}`}
                    key={index}
                >
                    <Div
                        className="cs-accordian_head"
                        onClick={() => handelToggle(index)}
                    >
                        <h2 className="cs-accordian_title">{item.question}</h2>
                        <span className="cs-accordian_toggle cs-accent_color">
                            <svg
                                width={15}
                                height={8}
                                viewBox="0 0 15 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M0 0L7.5 7.5L15 0H0Z" fill="currentColor" />
                            </svg>
                        </span>
                    </Div>
                    {selected === index && (
                        <Div className="cs-accordian_body">
                            <Div className="cs-accordian_body_in">{item.answer}</Div>
                        </Div>
                    )}
                </Div>
            ))}
        </Div>
    );
};


export default function CreativeSolutionHome() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <Hero10
                title="Scalable & Smart Tech Solutions For Growth"
                subtitle="We deliver best problem solving solution for our client and provide
        finest finishing product in present and upcoming future."
                btnLink="/contact"
                btnText="Let's Create Magic Together"
                bgImageUrl="/images/hero_bg_6.jpeg"   // ✅ Yeh sahi hai
                imgUrl="/images/hero_img_1.png"
                shape1Url="/images/hero_img_2.png"
                shape2Url="/images/hero_img_3.png"
                shape3Url="/images/hero_img_4.png"
            />
            <Spacing lg="145" md="80" />


            <Spacing lg="70" md="45" />
            <ServiceList />


            <Spacing lg="90" md="70" />
            <PortfolioSlider2 />


            <Spacing lg='150' md='80' />
            <TestimonialSlider />


            <Spacing lg='145' md='80' />
            <Div className="container cs-shape_wrap_4">
                <Div className="cs-shape_4"></Div>
                <Div className="cs-shape_4"></Div>
                <Div className="container">
                    <Div className="row">
                        <Div className="col-xl-5 col-lg-6">
                            <SectionHeading
                                title='Some Pre Questions And Answers'
                                subtitle='FAQs/Resources'
                            />
                            <Spacing lg='90' md='45' />
                        </Div>
                        <Div className="col-lg-6 offset-xl-1">
                            <CustomAccordion />
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80' />
            <Div className="container">
                <Cta
                    title="Let&apos;s Build The <br />Next Big Thing Together! "
                    btnText='Your Next Big Move Starts Here!'
                    btnLink='/contact'
                    bgSrc='/images/cta_bg.jpeg'
                />
            </Div>









            {/* <Div className="container">
                <SectionHeading
                    title="Design working process"
                    subtitle="UI/UX Design"
                    variant="cs-style1 text-center"
                />
                <Spacing lg="90" md="45" />
                <Div className="row">
                    <Div className="col-lg-4">
                        <IconBox
                            icon="/images/icons/service_icon_1.svg"
                            title="Sketching"
                            subtitle="Sed ut perspiciatis unde omnis iste natus error voluptatem accusantium also a doloremque laudantium, totam remain beatae vitae dictaro enim ipsam sunt explicabo."
                        />
                        <Spacing lg="30" md="30" />
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon="/images/icons/service_icon_2.svg"
                            title="Wireframing"
                            subtitle="Sed ut perspiciatis unde omnis iste natus error voluptatem accusantium also a doloremque laudantium, totam remain beatae vitae dictaro enim ipsam sunt explicabo."
                        />
                        <Spacing lg="30" md="30" />
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon="/images/icons/service_icon_3.svg"
                            title="Prototyping"
                            subtitle="Sed ut perspiciatis unde omnis iste natus error voluptatem accusantium also a doloremque laudantium, totam remain beatae vitae dictaro enim ipsam sunt explicabo."
                        />
                        <Spacing lg="30" md="30" />
                    </Div>
                </Div>
            </Div>
            <Spacing lg="120" md="50" /> */}
            {/* Start About Section */}
            {/* <section>
                <div className="container">
                    <div className="row align-items-center ">
                        <div className="col-lg-5">
                            <img
                                src="/images/about_img_9.jpeg"
                                alt="About"
                                className="w-100 cs-radius_5"
                            />
                        </div>
                        <div className="col-lg-6 offset-lg-1">
                            <div className="cs-height_0 cs-height_lg_40" />
                            <SectionHeading
                                title="Highly experienced pepole with us"
                                subtitle="Why Choose Us"
                                btnText="Learn More"
                                btnLink="/about"
                            >
                                <Spacing lg="30" md="20" />
                                <p>
                                    What distinguishes us from our competitors is our unwavering commitment to delivering specialized 360° marketing services meticulously tailored to meet the specific needs of our clients. Our dynamic and diverse team harnesses a rich tapestry of experience and expertise, enabling us to analyze and tackle each unique challenge with precision and insight.
                                    <br />
                                    <br />
                                    Over the years, we have come to understand that while each marketing channel presents its own complexities and intricacies, genuine success is forged through deep, nuanced expertise and a comprehensive understanding of the marketplace. This holistic approach allows us to navigate the evolving landscape with confidence and effectiveness, positioning our clients for sustained growth and success.
                                </p>
                            </SectionHeading>
                        </div>
                    </div>
                </div>
                <div className="cs-height_150 cs-height_lg_80" />
            </section> */}
            {/* End About Section */}
            {/* Start Servide Section */}
            {/* <div className="cs-gradient_1">
                <Spacing lg="150" md="80" />
                <Div className="cs-shape_wrap_4">
                    <Div className="cs-shape_4"></Div>
                    <Div className="cs-shape_4"></Div>
                    <Div className="container">
                        <Div className="row">
                            <Div className="col-xl-4">
                                <SectionHeading
                                    title="Services we can help you with"
                                    subtitle="What Can We Do"
                                />
                                <Spacing lg="90" md="45" />
                            </Div>
                            <Div className="col-xl-8">
                                <Div className="row">
                                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                                    <Div className="col-lg-3 col-sm-6">
                                        <Card
                                            title="UI/UX design"
                                            link="/service/ui-ux-design"
                                            src="/images/service_1.png"
                                            alt="Service"
                                        />
                                        <Spacing lg="0" md="30" />
                                    </Div>
                                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                                    <Div className="col-lg-3 col-sm-6">
                                        <Card
                                            title="React.js Development"
                                            link="/service/reactjs-development"
                                            src="/images/service_2.png"
                                            alt="Service"
                                        />
                                        <Spacing lg="0" md="30" />
                                    </Div>
                                    <Div className="col-lg-3 col-sm-6">
                                        <Card
                                            title="Digital Marketing"
                                            link="/service/digital-marketing"
                                            src="/images/service_3.png"
                                            alt="Service"
                                        />
                                        <Spacing lg="0" md="30" />
                                    </Div>
                                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                                    <Div className="col-lg-3 col-sm-6">
                                        <Card
                                            title="Technology"
                                            link="/service/technology"
                                            src="/images/service_4.jpeg"
                                            alt="Service"
                                        />
                                        <Spacing lg="0" md="30" />
                                    </Div>
                                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                                    <Div className="col-lg-3 col-sm-6">
                                        <Card
                                            title="Consultancy"
                                            link="/service/consultancy"
                                            src="/images/service_5.jpeg"
                                            alt="Service"
                                        />
                                        <Spacing lg="0" md="30" />
                                    </Div>
                                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                                    <Div className="col-lg-3 col-sm-6">
                                        <Card
                                            title="Creative Design"
                                            link="/service/creative-design"
                                            src="/images/service_6.jpeg"
                                            alt="Service"
                                        />
                                        <Spacing lg="0" md="30" />
                                    </Div>
                                </Div>
                            </Div>
                        </Div>
                    </Div>
                </Div>
                <Spacing lg="150" md="80" />
            </div> */}
            {/* End Servide Section */}
            {/* Start PortfolioSlider Section */}
            {/* <Spacing lg="120" md="50" />
            <Div className="container">
                <h2 className="cs-font_50 cs-m0 cs-line_height_4 text-center">
                    Our agile process is ability to adapt and respond to change. Agile
                    organizations view change as an opportunity, not a threat.
                </h2>
            </Div>
            <Spacing lg="90" md="70" />
            <PortfolioSlider2 /> */}
            {/* End PortfolioSlider Section */}
            {/* Start Testimonial Section */}
            {/* <section>
                <div className="cs-height_145 cs-height_lg_75" />
                <div className="container">
                    <SectionHeading
                        title="Voices of delights testimonials that <br />speak to our excellence"
                        subtitle="Clients Feedback"
                        variant="cs-style1 text-center"
                    />
                    <Spacing lg="90" md="45" />
                    <TestimonialSliderStyle3 />
                </div>
                <Spacing lg="150" md="80" />
            </section> */}
            {/* End Testimonial Section */}
            {/* Start CTA Section */}
            {/* <Cta
                title="Let&apos;s Bring ke <br />something <i>cool</i> together"
                btnText="Your Next Big Move Starts Here!"
                btnLink="/contact"
                bgSrc="/images/cta_bg_5.jpeg"
                variant="cs-type_1"
            /> */}
            {/* End CTA Section */}
            {/* Start Blog Section */}
            {/* <Spacing lg="150" md="80" />
            <Div className="cs-shape_wrap_4">
                <Div className="cs-shape_4"></Div>
                <Div className="cs-shape_4"></Div>
                <Div className="container">
                    <Div className="row">
                        <Div className="col-xl-4">
                            <SectionHeading
                                title="Explore recent publication"
                                subtitle="Our Blog"
                                btnText="View More Blog"
                                btnLink="/blog"
                            />
                            <Spacing lg="90" md="45" />
                        </Div>
                        <Div className="col-xl-7 offset-xl-1">
                            <Div className="cs-half_of_full_width">
                                <PostSlider />
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </Div> */}
            {/* End Blog Section */}
            {/* <Spacing lg="150" md="80" />
            <CtaStyle2
                bgUrl="images/video_bg_3.jpeg"
                btnText="Lets start <span>creative</span> things"
                btnLink="/contact"
            /> */}
        </>
    );
}
